import React, { useState } from 'react';
import DynamicEta from './dynamic-eta';
import DateFormatter from '../../shims/date-formatter.js';
import CookieUtils from '../../shims/cookie-utils.js';
import BackorderedDetails from './backordered-details.js';

function ShippingDetails({
  details,
  countDown={},
  select=()=>{}
}) {
  let dateRange = details.estimatedShippingStartDate !== details.estimatedShippingEndDate;

  let expectItDate = "";
  if(details.arrivalDate){
    expectItDate = DateFormatter.convertShortDayToLong(details.arrivalDate);
  }else if(details.estimatedShippingStartDate){
    const todayOrTomorrow = DateFormatter.checkIfTodayOrTomorrow(details.dynamicEtaOptimalDate);
    let longDynamicEtaOptimalDate = details.dynamicEtaOptimalDate;
    longDynamicEtaOptimalDate = DateFormatter.convertShortMonthToLong(details.dynamicEtaOptimalDate);
    longDynamicEtaOptimalDate = DateFormatter.convertShortDayToLong(longDynamicEtaOptimalDate);
    
    if(details.dynamicEtaOptimalDate &&  todayOrTomorrow){
      expectItDate = longDynamicEtaOptimalDate;
      // expectItDate = details.dynamicEtaOptimalDate;
    } else if (details.dynamicEtaOptimalDate && !todayOrTomorrow && !dateRange) {
       expectItDate = longDynamicEtaOptimalDate || details.estimatedShippingStartDate;
    } else if(!details.dynamicEtaOptimalDate && (details.rawEstimatedStartDeliveryDate || details.estimatedDeliveryDate)) {
      expectItDate = details.estimatedDeliveryDate || details.rawEstimatedStartDeliveryDate;
    }
    else if(dateRange){
      expectItDate = details.estimatedShippingStartDate + ' - ' + details.estimatedShippingEndDate;
    }
  }else if(details.backorderExpectedShipDate){
      expectItDate = details.backorderExpectedShipDate;
  }

  const showDynamicEta = () => { 
    if(details.dynamicEta && !countDown.timerExpired){
      if(details.isBackordered && details.backorderExpectedShipDate) {
        if(details.rawEstimatedShippingStartDate && dateRange){
          return true;
        }
        else{
          return false;
        }
      }else{   
        return true;
      } 
    }
    else{
      return false;
    }
  }
  
  let sthZipCode = details.sthZipCode || details.localStoreZipCode || "";
  return (
        <div className="heading-message">
          <BackorderedDetails 
          	details={details}
          	dateRange={dateRange}
          	expectItDate={expectItDate}
          />
          {!(details.isBackordered && !details.backorderExpectedShipDate) && (
            <span>
              {(!details.dynamicEta || countDown.timerExpired) && (<span className="quantity">
              {(details.rawEstimatedShippingStartDate) && (
                <span className="dai_detailsMessage">
                    {dateRange? "Expect it " : "Get it by " }<span className="u__bold"> { expectItDate }</span> to
                  <span className="u__bold"> {sthZipCode}</span>
                </span>
                )}
              </span>)}
              {showDynamicEta() 
            && (<span className="quantity dai_detailsMessage">Order within
                  <DynamicEta 
                    countdownHours={countDown.hours}
                    countdownMins={countDown.minutes}
                    countdownSecs={countDown.seconds}
                  /> to get it by
                  <span className="u__bold"> {expectItDate}</span> to
                  <span className="u__bold"> {sthZipCode}</span>
                </span>
                )}
                {!(details.isBackordered && !dateRange) && (
                  <div id="shipping_options_tooltip_link_container dai_deliveryOptionsLink">
                    <a className="u__default-link">
                      <span id="shipping_options_link" data-tip>Delivery Options</span>
                    </a>
                  </div>
                )}
                </span>
              )}
      </div>
    );
}

export default ShippingDetails;
